module.exports = __webpack_public_path__ + "img/entity.128125d8.svg";